/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caption_PositionInputs */



/**
* | output |
* | --- |
* | "Caption Position..." |
*
* @param {Caption_PositionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const caption_position = /** @type {((inputs?: Caption_PositionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caption_PositionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Position des sous-titres...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bildunterschriftenposition...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione didascalia...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позиция подписи...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posición de subtítulo...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标题位置……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプション位置...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन स्थिति...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição da legenda...")
	return /** @type {LocalizedString} */ ("Caption Position...")
});